import request from '@/utils/request'

// 获取用户有权限的菜单列表
export function getUserMenuList() {
  return request({
    url: '/menu/user/list',
    method: 'get'
  })
}

// 获取所有菜单列表（用于菜单管理）
export function getMenuList() {
  return request({
    url: '/menu/list',
    method: 'get'
  })
}

// 新增菜单
export function addMenu(data) {
  return request({
    url: '/menu/add',
    method: 'post',
    data
  })
}

// 更新菜单
export function updateMenu(data) {
  return request({
    url: '/menu/update',
    method: 'put',
    data
  })
}

// 删除菜单
export function deleteMenu(menuId) {
  return request({
    url: `/menu/delete/${menuId}`,
    method: 'delete'
  })
} 